/*
 *
 * ControlPanelUserManagementAmbassador reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_EMPLOYEES_DIVISIONS_FAILED,
  GET_EMPLOYEES_DIVISIONS_SUCCESS,
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  CREATE_AMBASSADOR_WATCHER,
  CREATE_AMBASSADOR_SUCCESS,
  CREATE_AMBASSADOR_FAILED,
  LIST_AMBASSADORS_WATCHER,
  LIST_AMBASSADORS_SUCCESS,
  LIST_AMBASSADORS_FAILED,
  DELETE_AMBASSADOR_WATCHER,
  DELETE_AMBASSADOR_FAILED,
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingDetails: true,
  listEmployees: [],
  listDivisions: [],
  isLoadingAmbassadorsCreate: false,
  isLoadingAmbassadors: false,
  listAmbassador: [],
  count_employees: 0,
  count_ambassadors: 0,
  count_all_ambassadors: 0,
  isDownloading: false,
})

function controlPanelUserManagementAmbassadorReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GET_LANGUAGE_WATCHER:
      return state.set("isLoadingLanguage", true)
    case GET_LANGUAGE_SUCCESS:
      return state
        .set("languages", action.payload)
        .set("isLoadingLanguage", false)
    case GET_LANGUAGE_FAILED:
      return state.set("isLoadingLanguage", false).set("languages", [])
    case GET_EMPLOYEES_DIVISIONS_WATCHER:
      return state.set("isLoadingDetails", true)
    case GET_EMPLOYEES_DIVISIONS_SUCCESS:
      return state
        .set("listEmployees", action.payload.employees)
        .set("listDivisions", action.payload.divisions)
        .set("isLoadingDetails", false)
    case GET_EMPLOYEES_DIVISIONS_FAILED:
      return state
        .set("listEmployees", [])
        .set("listDivisions", [])
        .set("isLoadingDetails", false)

    case CREATE_AMBASSADOR_WATCHER:
      return state
        .set("isLoadingAmbassadors", true)
        .set("isLoadingAmbassadorsCreate", true)
    case CREATE_AMBASSADOR_SUCCESS:
      return state.set("isLoadingAmbassadorsCreate", false)
    case CREATE_AMBASSADOR_FAILED:
      return state
        .set("isLoadingAmbassadors", false)
        .set("isLoadingAmbassadorsCreate", false)

    case LIST_AMBASSADORS_WATCHER:
      return state.set("isLoadingAmbassadors", true)
    case LIST_AMBASSADORS_SUCCESS:
      return state
        .set("isLoadingAmbassadors", false)
        .set("listAmbassador", action.payload.ambassadors)
        .set("count_employees", action.payload.count_employees)
        .set("count_all_ambassadors", action.payload.count_all_ambassadors)
        .set("count_ambassadors", action.payload.count_ambassadors)
    case LIST_AMBASSADORS_FAILED:
      return state.set("listAmbassador", []).set("isLoadingAmbassadors", false)

    case DELETE_AMBASSADOR_WATCHER:
      return state.set("isLoadingAmbassadors", true)
    case DELETE_AMBASSADOR_FAILED:
      return state.set("isLoadingAmbassadors", false)
    case GET_TEMPLATE_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_FAILED:
      return state.set("isDownloading", false)
    default:
      return state
  }
}

export default controlPanelUserManagementAmbassadorReducer
